import { LiquidityPoolDetails } from "#/shared/types"

// TODO: Temporary solution
export default function useLiquidityPools() {
  return {
    data: [
      {
        id: "0x7e6d67fd714194127973b7ef4748868a90392916",
        name: "MUSD/BTC",
        token0: {
          address: "0x637e22a1ebbca50ea2d34027c238317fd10003eb",
          name: "MUSD",
          totalAmount: 130850,
        },
        token1: {
          address: "0x7b7c000000000000000000000000000000000000",
          name: "BTC",
          totalAmount: 1.104935,
        },
        volume: 402.57,
        fees: 980.57,
        tvl: 22.57,
        apr: 18.8,
      },
      {
        id: "0xde1172b6f39712fcecf17edebe272828f8428c1a",
        name: "mUSDT/MUSD",
        token0: {
          address: "0x629320719a6190bd145c277226fd45e7648f950a",
          name: "mUSDT",
          totalAmount: 130850,
        },
        token1: {
          address: "0x637e22a1ebbca50ea2d34027c238317fd10003eb",
          name: "MUSD",
          totalAmount: 130850,
        },
        volume: 402.57,
        fees: 980.57,
        tvl: 22.57,
        apr: 18.8,
      },
    ] as LiquidityPoolDetails[],
    isFetching: false,
  }
}
